<template>
  <div>
    <el-form-item label="最大值">
      <el-input-number v-model="activeData.max" :min="1" :max="20" placeholder="最大值" />
    </el-form-item>
    <el-form-item v-if="activeData['allow-half'] !== undefined" label="允许半选">
      <el-switch v-model="activeData['allow-half']" />
    </el-form-item>
    <el-form-item label="辅助文字">
      <el-switch v-model="activeData['show-auxiliary-text']" @change="rateTextChange" />
    </el-form-item>
    <template v-if="activeData['show-auxiliary-text']">
      <el-form-item label="左边文字">
        <el-input v-model="activeData.textLeft" maxlength="10"  />
      </el-form-item>
      <el-form-item label="中间文字">
        <el-input v-model="activeData.textCenter" maxlength="10"  />
      </el-form-item>
      <el-form-item label="右边文字">
        <el-input v-model="activeData.textRight" maxlength="10"  />
      </el-form-item>
    </template>
    <el-form-item v-if="activeData['show-score'] !== undefined" label="显示分数">
      <el-switch v-model="activeData['show-score']" @change="rateScoreChange" />
    </el-form-item>
    <el-form-item v-if="activeData['show-stops'] !== undefined" label="显示间断点">
      <el-switch v-model="activeData['show-stops']" />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'ConfigItemRate',
  props: ['activeData'],
  methods: {
    rateTextChange(val) {
      if (val) this.activeData['show-score'] = false
    },
    rateScoreChange(val) {
      if (val) this.activeData['show-auxiliary-text'] = false
    }
  }
}
</script>

<style scoped></style>
